
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    InfiniteLoading
  }
})
export default class MyAccountCoin extends Vue {
  get pagePagination() {
    return this.$store.$myV2.Account.Coin.pagePagination
  }

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
